<form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
<odnr-map [enabled]="!isInReview" [config]="componentData.config" [accessPlan]="currentAccessPlan" (mapLoaded)="onMapReady($event)"></odnr-map>
<div style="display: flex;">
  <span style="display:inline-flex;">
    <label>
      Ingress
      <input type="radio" name="mode" value="ingress" (change)="ingressEgressChanged()" [(ngModel)]="ingressEgress" />
    </label>
  </span>
  <span style="display:inline-flex;">
    <label>
      Egress
      <input type="radio" name="mode" value="egress" (change)="ingressEgressChanged()" [(ngModel)]="ingressEgress" />
    </label>
  </span>
</div>
@if (currentAccessPlan !== undefined && currentAccessPlan !== null) {
  <div>
    <table>
      <caption>Route</caption>
      <thead>
        <tr>
          <th>Road Name</th>
        </tr>
      </thead>
      <tbody>
        @for (routeString of routeStrings; track routeString; let i = $index) {
          <tr>
            <td>{{i + 1}}) {{routeString.toString()}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}



